/**
 * How long a resource request can go without a status update before it moves
 * from the Active section to the Closed section of the queue.
 */
export const RESOURCE_REQUEST_ACTIVE_TIMEOUT_MS = 6 * 60 * 60 * 1000;
